import assetPath from '/opt/actions-runner/_work/crate/crate/packages/lebenslauf/constants/src/assets/cover-letter-1-preview.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')